<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Cabang">
        <template slot="button">
          <button-add v-if="cP(8)" :to="{name: 'companies-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/branches" :fields="fields">
            <template v-slot:4="data">
              <div class="float-none">
                <button-link size="sm" v-if="cP(11)" :to="{name:'companies-show',params:{id: data.item[4]}}" feather-icon="FolderIcon"></button-link>
                <button-link size="sm" v-if="cP(9)" :to="{name:'companies-edit',params:{id: data.item[4]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(10)" @ondelete="deleteRow" :id="data.item[4]" :name="data.item[0]"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Kode'},
        1:{sortable: true, searchable: true, label:'Nama'},
        2:{sortable: true, searchable: true, label:'Alamat'},
        3:{sortable: true, searchable: true, label:'Telepon'},
        4:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('companies/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>